import {
  AlcoholUseOptions,
  DrugUseOptions,
  ReasonVisitKey,
  SpecialtyCarePhrases,
  SpecialtyCareTypes,
} from './types';

export const MainVisitReasons: ReasonVisitKey[] = [
  'ADHD',
  'Anxiety',
  'Bipolar disorder',
  'Depression',
  'OCD',
  'PTSD',
  "I'm not sure",
];

export const SecondaryVisitReasons: ReasonVisitKey[] = [
  'Eating disorder',
  'Personality disorder',
  'Schizophrenia',
  'Self-harm',
  'Substance use disorder',
  'No, none of these apply',
];

export const alcoholUseOptions: AlcoholUseOptions[] = [
  'It feels healthy',
  'It feels unhealthy',
  "I'm not sure",
  "I don't drink alcohol",
];

export const drugUseOptions: DrugUseOptions[] = [
  'Yes, once a week or more',
  'Yes, once a month or more',
  'Yes, once a year or more',
  'No, never',
];

export const SpecialtyCareOptionsLabels: Record<SpecialtyCarePhrases, string> =
  {
    [SpecialtyCareTypes.LGBTQIA]: 'LGBTQIA+',
    [SpecialtyCareTypes.Perinatal]: 'Perinatal',
    [SpecialtyCareTypes.Surgical]: 'Surgical approval letter',
    [SpecialtyCareTypes.None]: 'None of these apply',
  };

export const SpecialtyCareOptions = Object.keys(
  SpecialtyCareOptionsLabels
) as SpecialtyCarePhrases[];
